import React from 'react';
import PropTypes from 'prop-types';
import { size } from 'lodash-es';

import { FindVinByAddressSelectVehicleView } from './find-vin-by-address-select-vehicle-view';
import { FindVinByAddressNotFoundView } from './find-vin-by-address-not-found-view';
import { FindVinByAddressNotFoundViewWithLp } from './find-vin-by-address-not-found-view-with-lp';

export const FindVinByAddressSubmittedView = ({
  vehicles = [],
  selectedVin = '',
  setSelectedVin,
  isSubmitting = false,
  continueWithSelectedVehicle,
  ctaBtnColor = '',
  isAddressTab = false,
  licensePlateAndVinForm = null,
  escapeHatchCta = null,
  isNoStyles = false,
}) => {
  if (size(vehicles) && !isNoStyles) {
    return (
      <FindVinByAddressSelectVehicleView
        vehicles={vehicles}
        selectedVin={selectedVin}
        setSelectedVin={setSelectedVin}
        isSubmitting={isSubmitting}
        continueWithSelectedVehicle={continueWithSelectedVehicle}
        ctaBtnColor={ctaBtnColor}
        isAddressTab={isAddressTab}
      />
    );
  }

  return isAddressTab ? (
    <FindVinByAddressNotFoundViewWithLp
      isAddressTab={isAddressTab}
      licensePlateAndVinForm={licensePlateAndVinForm}
      escapeHatchCta={escapeHatchCta}
    />
  ) : (
    <FindVinByAddressNotFoundView />
  );
};

FindVinByAddressSubmittedView.propTypes = {
  vehicles: PropTypes.arrayOf(PropTypes.shape({})),
  selectedVin: PropTypes.string,
  setSelectedVin: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  continueWithSelectedVehicle: PropTypes.func.isRequired,
  ctaBtnColor: PropTypes.string,
  isAddressTab: PropTypes.bool,
  licensePlateAndVinForm: PropTypes.node,
  escapeHatchCta: PropTypes.node,
  isNoStyles: PropTypes.bool,
};
